export const linkedIssuesInitialDisplayCount = 5;
